module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "m-form",
    attrs: {
      "name": "generalDamages"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.getAwards), function(award, awardIndex) {
    return _c('div', [_c('award', {
      attrs: {
        "awardIndex": awardIndex,
        "award": award
      },
      on: {
        "award-selected": _vm.selectedAward
      }
    })], 1)
  }), _vm._v(" "), (_vm.getTree !== null) ? _c('button', {
    staticClass: "a-button",
    on: {
      "click": _vm.addAward
    }
  }, [_vm._v("Add Another Award")]) : _vm._e(), _vm._v(" "), (_vm.getTree !== null) ? _c('div', {
    staticClass: "p-pi-income"
  }, [_c('h2', [_vm._v("General Damages Totals")]), _vm._v(" "), _c('div', {
    staticClass: "a-table a-table--short-no-style a-table--full-width u-margin-top-20"
  }, [_c('table', {
    staticClass: "a-table--full-width",
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.getAwards), function(award, awardIndex) {
    return _c('award-value-row', {
      key: awardIndex,
      attrs: {
        "award-index": awardIndex
      }
    })
  }), 1), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                                General Damages Total (100%)\n                            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getSubTotal)))])]), _vm._v(" "), _c('tr', {
    staticClass: "a-table--grey"
  }, [_c('td', {
    staticClass: "u-text-right u-bold",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                                General Damages Total (Discounted)\n                            ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.getSubTotalDiscounted)))])])])])])]) : _vm._e()], 2), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.isValid()
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v("Award")]), _vm._v(" "), _c('th', [_vm._v("JC Guidelines Chapter")]), _vm._v(" "), _c('th', [_vm._v("General Damages Award")]), _vm._v(" "), _c('th', [_vm._v("Discount %")]), _vm._v(" "), _c('th', [_vm._v("Sub Total")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8c581c5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/GeneralDamages.vue
// module id = 1769
// module chunks = 0